/**
 * Announcement Banner functionality
 * Handles close button interaction, localStorage persistence, and scroll-based margin adjustments
 */

document.addEventListener('DOMContentLoaded', function() {
    const banner = document.getElementById('announcement-banner');
    const closeButton = document.getElementById('announcement-banner-close');
    const body = document.body;
    
    if (!banner || !closeButton) {
        return;
    }
    
    // Check if banner was previously dismissed
    const isDismissed = localStorage.getItem('npi_announcement_banner_dismissed');
    
    if (isDismissed === 'true') {
        banner.style.display = 'none';
        return;
    }
    
    // Calculate and set banner height as CSS custom property
    function setBannerHeight() {
        const bannerHeight = banner.offsetHeight;
        document.documentElement.style.setProperty('--announcement-banner-height', bannerHeight + 'px');
    }
    
    // Set initial height
    setBannerHeight();
    
    // Update height on window resize
    window.addEventListener('resize', setBannerHeight);
    
    // Handle scroll to add/remove margin when banner is out of view
    let ticking = false;
    
    function updateScrollState() {
        const bannerBottom = banner.offsetHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > bannerBottom) {
            body.classList.add('banner-scrolled');
        } else {
            body.classList.remove('banner-scrolled');
        }
        
        ticking = false;
    }
    
    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(updateScrollState);
            ticking = true;
        }
    }
    
    window.addEventListener('scroll', onScroll);
    
    // Handle close button click
    closeButton.addEventListener('click', function() {
        banner.style.display = 'none';
        document.documentElement.style.setProperty('--announcement-banner-height', '0px');
        localStorage.setItem('npi_announcement_banner_dismissed', 'true');
        body.classList.remove('has-announcement-banner', 'banner-scrolled');
    });
    
    // Handle keyboard navigation
    closeButton.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            closeButton.click();
        }
    });
});